import { useContext } from 'react';

import UserInteractionContext from '@/Providers/UserInteractionContextProvider/UserInteractionContext';

import styles from './index.module.scss';

type Props = {
  /**
   * Whether the password is being set in a reset password flow.
   *
   * Note: since a user may not use the same identifier to sign in and reset password, the two
   * identifiers are cached separately.
   */
  readonly isForgotPassword?: boolean;
};

/** Current identifier for this password step; browser autofill hints are disabled. */
const HiddenIdentifierInput = ({ isForgotPassword = false }: Props) => {
  const { identifierInputValue, forgotPasswordIdentifierInputValue } =
    useContext(UserInteractionContext);

  const identifier = isForgotPassword ? forgotPasswordIdentifierInputValue : identifierInputValue;

  if (!identifier) {
    return null;
  }

  return (
    <input
      readOnly
      aria-hidden
      className={styles.hiddenIdentifierInput}
      tabIndex={-1}
      name="username"
      autoComplete="off"
      type="text"
      value={identifier.value}
    />
  );
};

export default HiddenIdentifierInput;
